import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HashAlgorithm } from '../shared/enums/hash-algorithm.enum';
import { Observable } from 'rxjs';
import { HeaderKey } from '../shared/enums/header-key.enum';
import { BackEndFingerprint } from '../shared/classes/fingerprint';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OpenIdService {
  private readonly httpClient = inject(HttpClient);


  //#region client
  public getFingerprint(entityId: string, hash: HashAlgorithm): Observable<string> {
    const url = `${entityId}/fingerprint/${hash}`;
    const headers = {
      [HeaderKey.Accept]: 'application/json',
    };
    return this.httpClient.get<BackEndFingerprint>(url, { headers }).pipe(
      map(response => response.fingerprint)
    );
  }
  //#endregion Client

}
